<template>
    <div class="page coupons-page px-md-8">
        <v-container class="py-3 py-lg-8 px-0">
            <transition name="fade-transition">
                <div v-if="couponsMeta">
                    <crud-table :actions="actions" show-search search-placeholder="ابحث باسم الكوبون" server-pagination :page-count="couponsMeta.last_page" :current-page="couponsMeta.current_page" :total="couponsMeta.total" :per-page="couponsMeta.per_page" create-button-text="إضافة كوبون" title="كوبونات الخصم" :items="couponsItems" :headers="headers" @load="loadMore" @reset="reset" @create="createDialog = true" @edit="openEditDialog" @delete="openDeleteDialog" @search="searchHandler" />
                </div>
            </transition>

            <action-dialog v-model="createDialog" scrollable max-width="420" vuex-action="createCoupon" success-msg="تم إضافة الكوبون بنجاح" title="إضافة كوبون خصم جديد" subtitle="أدخل بيانات الكوبون المراد إضافته" button-text="إضافة" :data="createForm" @reset="resetCreateForm">
                <div class="pt-1">
                    <v-text-field v-model="createForm.code" label="كود الخصم" placeholder="أدخل كود الخصم" prepend-inner-icon="mdi-credit-card-outline" hide-details class="mb-5"></v-text-field>
                    <v-text-field v-model="createForm.value" type="number" label="قيمة الخصم" placeholder="أدخل قيمة الخصم (مبلغ)" prepend-inner-icon="mdi-cash" hide-details class="mb-5"></v-text-field>
                    <v-text-field v-model="createForm.max_usages" type="number" label="أقصد حد للاستخدام (اختياري)" placeholder="أدخل عدد المرات المتاح فيها استخدام الكوبون" hide-details class="mb-5"></v-text-field>
                    <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field placeholder="تاريخ انتهاء صلاحية الكوبون (اختياري)" v-model="createForm.expires_at" hint="اترك الحقل فارغاً إن كان الكوبون بلا تاريخ انتهاء" label="تاريخ الانتهاء (اختياري)" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker ref="picker" v-model="createForm.expires_at" locale="ar" :min="today" @change="saveExpiresAt" color="primary"></v-date-picker>
                    </v-menu>
                </div>
            </action-dialog>
            
            <action-dialog v-model="editDialog" scrollable max-width="420" vuex-action="editCoupon" success-msg="تم تعديل الكوبون بنجاح" title="تعديل الكوبون" subtitle="تعديل بيانات الكوبون" button-text="حفظ" :data="{id: editedItem.id, data: {value: editedItem.value, max_usages: editedItem.max_usages, expires_at: editedItem.expires_at}}" @reset="resetEditForm">
                <div class="pt-1">
                    <v-text-field v-model="editedItem.value" type="number" label="قيمة الخصم" placeholder="أدخل قيمة الخصم (مبلغ)" hide-details class="mb-5"></v-text-field>
                    <v-text-field v-model="editedItem.max_usages" type="number" label="أقصد حد للاستخدام (اختياري)" placeholder="أدخل عدد المرات المتاح فيها استخدام الكوبون" hide-details class="mb-5"></v-text-field>
                    
                    <v-menu ref="menu2" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field placeholder="تاريخ انتهاء صلاحية الكوبون (اختياري)" v-model="editedItem.expires_at" clearable hint="اترك الحقل فارغاً إن كان الكوبون بلا تاريخ انتهاء" label="تاريخ الانتهاء (اختياري)" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker ref="picker" v-model="editedItem.expires_at" locale="ar" :min="today" @change="saveExpiresAt2" color="primary"></v-date-picker>
                    </v-menu>
                </div>
            </action-dialog>

            <action-dialog v-model="deleteDialog" vuex-action="deleteCoupon" :title="`حذف كوبون الخصم`" :data="{id: deleteItem ? deleteItem.id : null}" button-text="تأكيد الحذف" button-color="error">
                هل أنت متأكد من حذف الكوبون <span class="strong-text--text">"{{deleteItem ? deleteItem.code : ''}}"</span> ؟
            </action-dialog>
            
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CrudTable from '@/components/default/crud-table'

export default {
    name: "Coupons",
    components: {
        CrudTable
    },
    data(){
        const now = new Date();

        return {
            loading: false,   
            createDialog: false,
            createForm: {
                code: '',
                value: '',
                max_usages: '',
                expires_at: '',
            },
            today: now.toISOString().substr(0, 10),
            
            editDialog: false,
            editedItem: {
                id: '',
                value: '',
                max_usages: '',
                expires_at: '',
            },
            
            deleteDialog: false,
            deleteItem: null,

            headers: [
                {
                    text: 'إجراءات',
                    align: 'start',
                    sortable: false,
                    value: 'item_id',
                },
                {
                    text: 'كود الخصم',
                    align: 'start',
                    sortable: false,
                    value: 'code',
                },
                {
                    text: 'قيمة الخصم',
                    align: 'center',
                    sortable: false,
                    value: 'value',
                    money: true,
                },
                {
                    text: 'أقصى حد للاستخدام',
                    value: 'max_usages',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'عدد الاستخدامات',
                    value: 'orders_count',
                    align: 'center',
                    sortable: false,
                    number: true,
                },
                {
                    text: 'تاريخ الانتهاء',
                    value: 'expires_at',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'الحالة',
                    align: 'center',
                    sortable: false,
                    value: 'status',

                    chip: true,
                    chipFunction: this.handleStatus,
                },
                {
                    text: 'وقت اﻹنشاء',
                    value: 'created_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    computed: {
        ...GlobalComputed,
        coupons(){
            return this.$store.state.storeModule.coupons;
        },
        couponsMeta(){
            return this.$store.state.storeModule.couponsMeta;
        },
        couponsItems(){
            return this.coupons ? this.coupons.map(coupon=>{
                return {
                    ...coupon,
                    item_id: '',
                };
            }) : [];
        },
        actions(){
            return [
                {name: 'edit', text: 'تعديل', icon: 'mdi-square-edit-outline', color: 'text'},
                {name: 'delete', text: 'حذف', icon: 'mdi-delete', color: 'red darken-1'}
            ]
        },
        searchQuery(){
            return this.$route.query.search;
        }
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        searchQuery(query){
            this.loadData();
        }
    },
    methods: {
        ...GlobalMethods,
        resetCreateForm(){
            this.createForm = {
                code: '',
                value: '',
                max_usages: '',
                expires_at: '',
            };
        },
        saveExpiresAt(date){
            this.$refs.menu.save(date);
        },
        saveExpiresAt2(date){
            this.$refs.menu2.save(date);
        },
        openEditDialog(item){
            Object.assign(this.editedItem, item);
            this.editDialog = true;
        },
        openDeleteDialog(item){
            this.deleteDialog = true;
            this.deleteItem = item;
        },
        loadData(page=1){
            if (!this.loading){
                this.loading = true;
                const query = this.searchQuery || null;
                this.$store.dispatch('getCoupons', {page, query}).then(response=>{
                    this.loading = false;
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل كوبونات الخصم', 'error');
                })
            }
        },
        loadMore(payload){
            this.loadData(payload.page);
        },
        reset(){
            if (this.searchQuery){
                this.$router.replace({query: {}})
            }
            this.loadData();
        },
        resetEditForm(){
            this.editedItem = {
                id: '',
                code: '',
                value: '',
                max_usages: '',
                expires_at: '',
            }
        },
        searchHandler(search){
            this.$router.replace({query: {search}})
        }
    },
    mounted(){
        if (this.subscription === 'advanced'){
            this.loadData();
        }else{
            this.$router.push('not-found');
        }
    }
};
</script>
